<script setup>
import { computed, inject, ref } from 'vue'
import RemakeHeader from '@/__core__/components/headers/remake-header/RemakeHeader.vue'
import ScrollingContainer from '@/__core__/containers/scrolling-container/ScrollingContainer.vue'
import { loc } from '@/__core__/localization/localization'

const props = defineProps({
  data: Object
})

const langId = inject('langId', '')

const prepareHeadrPerMatch = match => {
  const { teams, round, competition, startTime, periodScores = [], status, score, outcome } = match
  let home = teams.find(team => team.qualifier === 'home')
  home.score = score.home
  let away = teams.find(team => team.qualifier === 'away')
  away.score = score.away
  let penaltiesScore = periodScores.find(period => period.type === 'penalties')
  const startDate = new Date(startTime) // Convert to Date object
  const currentDate = new Date() // Get the current date and time
  let competitionLabel = competition.name
  const isGameLive = status.live

  let fullStatus
  if (outcome === 'W') {
    fullStatus = 'won'
  } else if (outcome === 'L') {
    fullStatus = 'lose'
  } else {
    fullStatus = 'draw'
  }

  if (round.number) {
    competitionLabel += `, ${loc('sm_round_rs', langId)} ${round.number}`
  } else if (round.name) {
    const labelKey = `sm_${round.name}`
    competitionLabel += `, ${loc(labelKey, langId)}`
  } else {
    // do nothing
  }

  return {
    matchStatus: loc(`sm_form_${fullStatus}`, langId),
    home,
    away,
    startTime,
    isGameLive,
    competitionLabel,
    status: outcome,
    upcoming: startDate > currentDate,
    penaltiesScore: penaltiesScore && `${penaltiesScore.home}:${penaltiesScore.away}`,
    formStatus: true
  }
}

const formOverviewContainerRef = ref(null)
const formContainerRef = ref(null)

const formOverviewContainerHeight = computed(() => formOverviewContainerRef?.value?.clientHeight || 0)
const formOverviewContainerWidth = computed(() => formOverviewContainerRef?.value?.clientWidth || 0)
</script>

<template>
  <div class="szw-flex szw-h-full szw-relative szw-gap-1" ref="formOverviewContainerRef">
    <scrolling-container
      :widget-container-height="formOverviewContainerHeight"
      :container-ref="formContainerRef"
      :container-id="data?.teamName"
      :button-offset="0"
      :disableAnimationWhenReseting="true"
    >
      <div class="szw-scrollable-container" ref="formContainerRef">
        <remake-header 
          v-for="match in props.data?.formEntries"
          :key="match.eventId"
          :header-data="prepareHeadrPerMatch(match)"
          :has-shadow="false"
          :size="formOverviewContainerWidth"
          class="szw-border szw-border-border szw-border-solid"
        />
      </div>
    </scrolling-container>
  </div>
</template>
